export const AppcuesEvent = {
  AddItemToCart: 'add item to cart',
  SubmitOrder: 'submit order',
  AddItemToWishlist: 'add item to wishlist',
};
